import React, { useState, useRef, useEffect } from "react";
import _ from "lodash";
import RetailDesignationForm from "./RetailDesignationsForm";
import LdnDesignationForm from "./LdnDesignationForm";
import Sandoz from "~/images/Sandoz.png";

const SandozDesignations = ({ entities, setCompletedDesignations }) => {
  const manufacturer = "sandoz";
  const manufacturerName = "Sandoz";
  const [retailHasSelectedSpecialtyPharmacy, setRetailHasSelectedSpecialtyPharmacy] = useState(false);
  const [retailSelectedSpecialtyPharmacy, setRetailSelectedSpecialtyPharmacy] = useState();
  const [manufacturerFormDetails, setManufacturerFormDetails] = useState({
    sandoz: {},
  });

  const sharedProps = {
    entities,
    manufacturer,
    manufacturerName,
    manufacturerFormDetails,
    setManufacturerFormDetails,
    retailSelectedSpecialtyPharmacy,
    retailHasSelectedSpecialtyPharmacy,
  };

  useEffect(() => {
    setCompletedDesignations(isComplete());
  }, [manufacturerFormDetails]);

  const isComplete = () => {
    var completed = true;

    var openForms = _.map(manufacturerFormDetails, (manufacturer) => {
      return _.filter(manufacturer, (form) => {
        return form.open;
      });
    });

    // remove empty arrays and flatten
    var filteredForms = openForms.filter((e) => e.length).flat();

    if (filteredForms.length) {
      completed = _.every(filteredForms, ["completed", true]);
    }

    return completed;
  };

  const renderRetail = () => {
    return (
      <RetailDesignationForm
        entities={entities}
        kind={"retail"}
        manufacturerFormDetails={manufacturerFormDetails}
        setManufacturerFormDetails={setManufacturerFormDetails}
        manufacturer={manufacturer}
        manufacturerName={manufacturerName}
        setRetailSelectedSpecialtyPharmacy={setRetailSelectedSpecialtyPharmacy}
        setRetailHasSelectedSpecialtyPharmacy={setRetailHasSelectedSpecialtyPharmacy}
      />
    );
  };

  const renderDesignationForm = (Component, specialtyKeyName) => (
    <Component
      {...sharedProps}
      isBlocked={_.some(entities, (e) => e.blocked.includes(specialtyKeyName))}
      productName={specialtyKeyName}
    />
  );



  return (
    <div>
      <div className="designation_form__section__header">
        <div className="designation_form__section__header__logo">
          <img src={Sandoz} />
        </div>
        <div className="designation_form__section__header__title">{manufacturerName}</div>
      </div>

      {renderRetail()}
      {renderDesignationForm(LdnDesignationForm, "tyruko")}

    </div>
  );
};

export default SandozDesignations;
